import { EditorContent } from '@tiptap/react'
import { SERVICES_FORMS_ENDPOINT, SERVICE_REQUESTS_ENDPOINT } from 'api/endpoints'
import classNames from 'classnames'
import { ButtonV2 } from 'components/Button'
import Footer from 'components/Footer'
import { FormField, FormFieldNative } from 'components/Form'
import { Input } from 'components/Input'
import { NamedModalWindow } from 'components/ModalWindow'
import { Navbar } from 'components/Navbar'
import { Textarea } from 'components/Textarea'
import { useAPIFetch } from 'hooks/fetch'
import { useSimpleEditor } from 'hooks/simple-editor'
import { useUser } from 'hooks/user'
import { genericToastErrorMessage } from 'lib/errors'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { PropsWithChildren, useEffect, useId, useState } from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { twMerge } from 'tailwind-merge'
import { handleFetchError } from 'utils/fetch'
import { PropsWithClass, PropsWithClassAndStyle } from 'utils/props'
import {services} from 'data/services'
import SimpleBubbleMenu from 'components/simple-editor/SimpleBubbleMenu';
import { BubbleMenu } from 'components/simple-editor/TiptapBubbleMenu';
import { ServiceRequestAttachment } from 'models/service-request'

type ServiceCardProps = PropsWithChildren<{
  icon: string
  name: string
}>

function ServiceCard({ icon, name, children }: ServiceCardProps) {
  return <div className="flex flex-col items-center gap-1 w-[30%] mx-auto">
    <img src={icon} width={72} height={72} />
    <h2 className="text-xl text-center font-bold w-[80%]">{name}</h2>
    <p className="text-center w-[80%]">{children}</p>
  </div>
}


function RequestForm({ open, close, onSubmit }: { open: boolean; close: () => void; onSubmit: (email: string, comment: string, services: string[], files: File[]) => any }) {
  const [user] = useUser()
  const [email, setEmail] = useState('')
  const [comment, setComment] = useState('')
  const [selectedServices, setSelectedServices] = useState<string[]>([])
  const fileUploadId = useId()
  const [files, setFiles] = useState<File[]>([])

  const editor = useSimpleEditor({
    editorProps: {
      attributes: {
        class: 'w-full w-full min-h-7 resize-y max-h-10 border border-light-grey rounded-lg p-0.2 px-0.5',
      }
    },
    placeholder: 'Пожалуйста, опишите нам детали обращения: тематику статьи, тип услуги, ключевые требования (журналы, сроки, язык, формат), а также прикрепите важные файлы (черновик, рецензии, список терминов)',
    onUpdate: ({editor}) => {
      setComment(editor.getHTML())
    }
  })

  const handleUpload = async (newFiles: File[]) => {
    setFiles([...files, ...newFiles])
  }
  const [uploading, setUploading] = useState(false)
  useEffect(() => {
    if (user?.bio?.corporate_email)
      setEmail(user.bio.corporate_email)
  }, [user])
  return <NamedModalWindow name="Экспертные услуги" open={open} close={close} /* className="h-48 max-4xl:h-40 max-3xl:h-35 max-2xl:h-30 max-xl:h-27 w-30" */ className="w-40 h-[70%] overflow-hidden">
    <form onSubmit={e => {
      e.preventDefault()
      onSubmit(email, comment, selectedServices, files)
    }} className="flex flex-col w-full gap-1">
      <div className="flex flex-col items-start gap-1 h-full px-0.2">
        <FormFieldNative name="Почта для обратной связи" className="w-full" required>
          <Input value={email} setValue={setEmail} placeholder="support@research-helper.ru" className="w-full" type="email" name="email" />
        </FormFieldNative>
        {/* <FormFieldNative name="Запрос" className="w-full"> */}
        {/*   <Textarea value={comment} setValue={setComment} placeholder="Пожалуйста, опишите нам детали обращения: тематику статьи, тип услуги, ключевые требования (журналы, сроки, язык, формат), а также прикрепите важные файлы (черновик, рецензии, список терминов)" className="w-full min-h-7 resize-y max-h-10" /> */}
        {/* </FormFieldNative> */}
        {/* <FormFieldNative name="Запрос" className="w-full"> */}
        {/*   <Textarea value={comment} setValue={setComment} placeholder="Пожалуйста, опишите нам детали обращения: тематику статьи, тип услуги, ключевые требования (журналы, сроки, язык, формат), а также прикрепите важные файлы (черновик, рецензии, список терминов)" className="w-full min-h-7 resize-y max-h-10" /> */}
        {/* </FormFieldNative> */}
                <FormFieldNative name="Запрос" className="w-full">
          <EditorContent editor={editor} />
                                <BubbleMenu editor={editor} options={{placement:'top-start'}}>
                <SimpleBubbleMenu editor={editor} />
              </BubbleMenu>
        </FormFieldNative>

        <FormFieldNative name="Файлы" className="w-full">
          <label htmlFor={fileUploadId} className="w-full border border-grey border-dashed flex justify-center gap-1 p-1 rounded-xl mt-1 cursor-pointer"
            id="services-upload-btn"
            onDrop={e => {
              e.preventDefault()
              console.log('lol')
              handleUpload(Array.from(e.dataTransfer.files))
              setUploading(false)
            }} onDragOver={(event) => {
              event.preventDefault()
              setUploading(true)
            }} onDragLeave={e => {
              e?.preventDefault()
              setUploading(false)
            }}>
            <input type="file" id={fileUploadId} className="hidden" accept=".docx" onChange={e => {
              e.preventDefault()
              handleUpload(Array.from(e.target.files!))
              e.currentTarget.value = ""
            }} />

            <img src="/images/upload.svg" className="w-1 h-1" />
            {!uploading && <p>Загрузить файл</p>}
          </label>

          <div className="mt-1">
            {files.map((v, idx) => <div className="flex flex-row justify-between items-center" key={idx}>
              <div className="flex flex-row gap-0.5 items-center">
                <img src="/images/info/file.svg" className="w-2 h-auto" />
                <span>{v.name}</span>
              </div>
              <button onClick={e => {
                e.preventDefault()
                const tmp = [...files]
                tmp.splice(idx, 1)
                setFiles(tmp)
              }}>
                <img src="/images/remove-red.svg" className="w-1 h-1" />
              </button>
            </div>)}
          </div>

        </FormFieldNative>
        <FormFieldNative name="Экспертные услуги" className="w-full">
          <div className="flex flex-col gap-1">
            {services.map(v => <div className="w-full flex flex-col gap-1" key={v[0]}>
              <button className={classNames("flex flex-row items-center gap-0.5 border text-start border-light-grey flex-1 p-0.5 rounded-xl", {
                "border-secondary ": !!selectedServices.find(v2 => v2 === v[0]),
              })} onClick={e => {
                e.preventDefault()
                const service = selectedServices.findIndex(v2 => v2 === v[0])
                if (service === -1) setSelectedServices([...selectedServices, v[0]])
                else {
                  const tmp = [...selectedServices]
                  tmp.splice(service, 1)
                  setSelectedServices(tmp)
                }
              }}>
                <img src={v[1]} className="w-2 h-auto" />
                <span>{v[0]}</span>
              </button>
              {v[2] && <div hidden={!selectedServices.find(v2 => v2 === v[0])} className="text-sm mb-1 mt-0.5">
                <b>Пример запроса: </b> {v[2]}
              </div>}
            </div>)}
          </div>
        </FormFieldNative>
      </div>

      <div className="flex flex-row gap-1 justify-end border-t border-light-grey w-full pt-1">
        <ButtonV2 colorscheme="light" onClick={close}>Отмена</ButtonV2>
        <ButtonV2 disabled={!selectedServices.length || !email} type="submit">Отправить</ButtonV2>
      </div>
    </form>
  </NamedModalWindow>
}


type ServiceRequestAttachmentCreate = {
  name: string
  mime_type: string
  data_base64: string
}

export default function Services() {
  const [user] = useUser()
  const router = useRouter()
  const [requestOpen, setRequestOpen] = useState(false)
  const apiFetch = useAPIFetch()

  const handleSubmit = useMutation({
    mutationFn: async ({ email, comment, services, files }: { email: string; comment: string; services: string[]; files: File[] }) => {
      // const fb64: Array<{ data_base64: string; name: string }> = []
      // for (const v of files) {
      //   fb64.push({ data_base64: Buffer.from(await v.arrayBuffer()).toString('base64'), name: v.name })
      // }
      // await handleFetchError(apiFetch(SERVICES_FORMS_ENDPOINT, {
      //   method: 'POST',
      //   body: JSON.stringify({
      //     email,
      //     comment,
      //     files: fb64,
      //     services,
      //   })
      // }))
      const attachments: ServiceRequestAttachmentCreate[] = []

      for (const f of files) {
        attachments.push({
          name: f.name,
          mime_type: f.type !== '' ? f.type : 'text/plain',
          data_base64: Buffer.from(await f.arrayBuffer()).toString('base64'),
        })
      }
      
      await handleFetchError(apiFetch(SERVICE_REQUESTS_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify({
          message: comment,
          selected_services: services,
          attachments: attachments
        })
      }))
    },
    onSuccess: async () => {
      toast.success('Форма успешно отправлена')
      setRequestOpen(false)
    },
    onError: async () => toast.error(genericToastErrorMessage),
  })
  return <>
    <Head>
    </Head>
    <Navbar user={user} static />
    <div className="flex flex-col gap-3 items-center justify-center t-2 mt-2">
      {/* <h1 className="font-bold text-6xl mt-3 mb-1 w-[1500px]">Сервисы</h1> */}
      <div>
        <h1 className="text-center text-4xl font-bold">Экспертные услуги<br /> для&nbsp;вашего научного успеха</h1>
        <p className="mt-2 text-semidark-grey mx-auto text-center w-[40%]">
          Выбирая <span className="text-secondary font-semibold">Research Helper</span>, вы&nbsp;выбираете путь к&nbsp;научной ясности, точности и&nbsp;признанию в&nbsp;академическом сообществе. Заполните форму, чтобы начать сотрудничество с&nbsp;экспертами, которые помогут вашей работе занять достойное место в&nbsp;мире научных&nbsp;открытий
        </p>
        <div className="flex flex-row justify-between flex-wrap gap-y-4 mt-6">
          <ServiceCard icon="/images/info/correction.svg" name="Первичное редактирование / коррекция">
            Улучшите структуру и&nbsp;языковое оформление вашей рукописи для&nbsp;обеспечения её научной выразительности и&nbsp;четкости
          </ServiceCard>
          <ServiceCard icon="/images/info/pre-review.svg" name="Редактирование перед рецензированием">
            Подготовьте вашу статью к&nbsp;критическому анализу и&nbsp;оценке рецензентами
          </ServiceCard>
          <ServiceCard icon="/images/info/journal-selection.svg" name="Помощь с&nbsp;выбором журнала для&nbsp;публикации">
            Наши эксперты помогут определить подходящее издание, соответствующее научному направлению и&nbsp;уровню вашего исследования
          </ServiceCard>

          <ServiceCard icon="/images/info/article-notification.svg" name="Получение подтверждения о&nbsp;принятии статьи к&nbsp;публикации">
            Оформите официальное подтверждение принятия Вашей статьи в печать для предоставления в отчетах по грантам, диссертационным советам или другим организациям
          </ServiceCard>
          <ServiceCard icon="/images/info/infographics.svg" name="Инфографика для&nbsp;статьи">
            <br />Повысьте восприятие вашего исследования<br /> с&nbsp;помощью профессионально созданных схем,<br />таблиц и&nbsp;рисунков
          </ServiceCard>
          <ServiceCard icon="/images/info/article-maintenance.svg" name="Ведение статьи после получения рецензии / ответы на&nbsp;вопросы рецензента">
            Оптимизируйте процесс редактирования<br /> с&nbsp;нашей поддержкой в&nbsp;ответах на&nbsp;замечания рецензентов
          </ServiceCard>
          <ServiceCard icon="/images/info/translation.svg" name="Академический перевод">
            Расширьте аудиторию вашего исследования<br /> с&nbsp;помощью точного и&nbsp;профессионального перевода
          </ServiceCard>
        </div>
        <div className="flex justify-center mt-4 w-full"><ButtonV2 className="py-0.5 w-[400px]" colorscheme="default-outline-hover" onClick={() => setRequestOpen(true)}>Заполнить форму</ButtonV2></div>
        {requestOpen && <RequestForm open={requestOpen} close={() => setRequestOpen(false)} onSubmit={(email, comment, services, files) => handleSubmit.mutate({ email, comment, services, files })} />}
      </div>
      <div className="rounded-lg flex flex-row gap-5 px-4 mb-5 mt-2">
        {/* TODO: on smaller screens make it flex col */}
        <div className={classNames("flex-1 flex flex-col justify-center gap-2 padding-0.5")}>
          <img src="/images/info/intellichecker-service9.png" className="border border-light-grey rounded-xl w-25 2xl:w-30 3xl:w-43 p-0.5 h-auto" />
        </div>

        <div className={classNames("flex-1 flex flex-col justify-center gap-2")}>
          <h1 className="text-4xl font-bold">Проверка рукописи</h1>
          {/* <p className="max-w-[70%]"> */}
          <p className="max-w-[90%]">
            Обеспечьте безупречное качество вашей медицинской статьи перед отправкой в&nbsp;редакцию с&nbsp;помощью <span className="text-secondary font-semibold">IntelliChecker</span>.
            <br /><br />
            Наш сервис, разработанный на&nbsp;основе алгоритмов искусственного интеллекта и&nbsp;анализа естественного языка, гарантирует детальную проверку соответствия вашего текста всем требованиям ведущих научных медицинских изданий.
          </p>
          <ButtonV2 className="py-0.5 w-[400px]" colorscheme="default-outline-hover" onClick={() => router.push('/intellichecker')}>Загрузить статью</ButtonV2>
        </div>
      </div>
    </div>
    <Footer />
  </>
}
